import React, { useState } from 'react';
import Button from '@components/common/Button';
import { postDataWithResponse } from '@services/CommonApiService';
import { errorLogger } from '@utils/applicationLogUtils';
import { downloadPdf } from '@utils/pdfUtility';
import CommonModal from '@components/common/CommonModal';
import ButtonModal from '@components/common/Button';
import ViewDocument from '@components/common/ViewDocument';
import { CHILD_DETAILS } from '@pages/Beneficiary-block/WomenComponent/Child/ChildtrackingConstant';
import config from '@config/config';
import './McpCard.css';

interface IMcpCard {
  apiUrl: any;
  healthPassportApiUrl?: any;
  id: string;
  gender?:string;
}

const McpCard = ({ apiUrl, healthPassportApiUrl, id, gender }: IMcpCard) => {
  const [mcpCardDataBinary, setMcpCardDataBinary] = useState<any>('');
  const [showMcpViewCard, setShowMcpViewCard] = useState<boolean>(false);

  const getMCPCardData = async () => {
    try {
      const response: any = await postDataWithResponse(
        apiUrl,
        { id },
        { responseType: 'blob' },
      );
      setMcpCardDataBinary(response);
      setShowMcpViewCard(true);
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
    }
  };

  const closeMcpViewCardModal = () => {
    setShowMcpViewCard(false);
    setMcpCardDataBinary(null);
  };

  const downloadMcpCard = async () => {
    downloadPdf(mcpCardDataBinary);
  };

  const downloadHealthPassport = async () => {
    if (!healthPassportApiUrl) {
      return;
    }
    try {
      const response: any = await postDataWithResponse(
        healthPassportApiUrl,
        { id },
        { responseType: 'blob' },
      );

      downloadPdf(response);

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 1000);
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
    }
  };

  return (
    <>
      <div className="mcp-card-buttons">
        {(config.isDownloadMCPButtonVisible && healthPassportApiUrl) && (
        <div className="mcp-card-button-wrapper">
          <Button
            onClick={downloadHealthPassport}
            disabled={gender?.toLowerCase() === 'male'}
            id={'download_health_passport'}
            buttonName={CHILD_DETAILS.DOWNLOAD_HEALTH_PASSPORT_BTN}
            colorType={'primary'}
          />
        </div>
        )}
        <div className="mcp-card-button-wrapper">
          <Button
            onClick={getMCPCardData}
            disabled={false}
            id={'view_mcp_card'}
            buttonName={CHILD_DETAILS.VIEW_MCP_CARD_BTN}
            colorType={'primary'}
          />
        </div>
      </div>

      {showMcpViewCard && (
        <CommonModal
          show={setShowMcpViewCard}
          handleClose={closeMcpViewCardModal}
          title="MCH Card"
          size="lg"
          footer={
            <>
              <ButtonModal
                onClick={closeMcpViewCardModal}
                id="cancel"
                buttonName={CHILD_DETAILS.CANCEL}
                colorType={'secondary'}
              />
              <ButtonModal
                onClick={downloadMcpCard}
                id="download"
                buttonName={CHILD_DETAILS.DOWNLOAD}
                colorType={'primary'}
              />
            </>
          }
        >
          <ViewDocument pdfBytes={mcpCardDataBinary.data} />
        </CommonModal>
      )}
    </>
  );
};

export default McpCard;
